import { render, staticRenderFns } from "./newTemplateWithAi.vue?vue&type=template&id=edf2c7b2&scoped=true"
import script from "./newTemplateWithAi.vue?vue&type=script&lang=js"
export * from "./newTemplateWithAi.vue?vue&type=script&lang=js"
import style0 from "./newTemplateWithAi.vue?vue&type=style&index=0&id=edf2c7b2&prod&scoped=true&lang=css"
import style1 from "./newTemplateWithAi.vue?vue&type=style&index=1&id=edf2c7b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf2c7b2",
  null
  
)

export default component.exports